export default __webpack_public_path__ + "static/media/image.inventricx-pvt-ltd.0b10a34a.png";